import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import FieldLabel from '../components/FieldLabel';
import { getFieldLabel } from '../utils/formHelpers';
import { outlinedFieldProps } from '../utils/fieldStyles';

const DropdownField = ({ field, data, change, hasError, errorMessage, resolveFieldOptions }) => {
    let options = resolveFieldOptions?.(field) || field.options || [];
    const addonType = data?.addon_type;
    const isAesbScope =
        field.key === 'application_scope'
        && (addonType === 'arrive_early' || addonType === 'stay_behind');
    const disabled = Boolean(field.disabled || field.readOnly || isAesbScope);

    if (isAesbScope) {
        const locked = addonType === 'arrive_early' ? 'before_trip' : 'after_trip';
        options = (field.options || []).filter((o) => o.value === locked);
    }

    return (
        <TextField
            {...outlinedFieldProps}
            select
            label={<FieldLabel label={getFieldLabel(field)} tooltip={field.tooltip} />}
            value={data[field.key] || ''}
            onChange={(e) => {
                if (disabled) return;
                change(field.key, e.target.value);
            }}
            disabled={disabled}
            InputProps={disabled ? { readOnly: true } : undefined}
            error={hasError}
            helperText={
                hasError
                    ? (errorMessage || 'This field is required')
                    : (isAesbScope
                        ? 'Set automatically from Add-on Type'
                        : (field.helperText || ''))
            }
        >
            {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
            ))}
        </TextField>
    );
};

export default DropdownField;
